import { NgModule } from "@angular/core"
import {
  MatButtonModule,
  MatDialogModule,
  MatInputModule,
  MatSnackBarModule,
  MD_ERROR_GLOBAL_OPTIONS,
  showOnDirtyErrorStateMatcher
} from "@angular/material"

const modules = [MatButtonModule, MatDialogModule, MatInputModule, MatSnackBarModule]

@NgModule({
  imports: modules,
  providers: [
    {
      provide: MD_ERROR_GLOBAL_OPTIONS,
      useValue: {
        errorStateMatcher: showOnDirtyErrorStateMatcher
      }
    }
  ],
  exports: modules
})
export class AppMaterialModule {}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/app-material.module.ts